import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/styles';
import { useMediaQuery } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { Sidebar } from './components';
import TopBar from '../../containers/TopBarContainer';
import { useCurrentUserInfo } from '../../hooks/useCurrentUserInfo';
import {
  currentFileSelector,
  findFileByUserId
} from '../../redux/features/file/filesSlice';
import {
  companyFetchedSelector,
  currentCompanySelector,
  fetchCompanyByUserId
} from '../../redux/features/company/companiesSlice';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 56,
    height: '100%',
    [theme.breakpoints.up('sm')]: {
      paddingTop: 64
    }
  },
  shiftContent: {
    paddingLeft: 240
  },
  content: {
    height: '100%'
  }
}));

const Main = ({ children }) => {
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  const { userId } = useCurrentUserInfo();
  const currentFile = useSelector(currentFileSelector);
  const currentCompany = useSelector(currentCompanySelector);
  const companyFetched = useSelector(companyFetchedSelector);
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {
    defaultMatches: true
  });

  const [openSidebar, setOpenSidebar] = useState(false);

  // Fetch company data for the logged-in user using Redux Thunk
  useEffect(() => {
    if (userId && !companyFetched && !currentCompany?.id) {
      console.log('🏢 [Main Layout] Fetching company for userId:', userId);
      dispatch(fetchCompanyByUserId({ userId }));
    }
  }, [userId, companyFetched, currentCompany, dispatch]);

  // Fetch company logo file when user logs in or when company has a fileIdLogo
  useEffect(() => {
    if (userId) {
      // Check if company has a logo file ID and we haven't loaded that file yet
      const companyFileId = currentCompany?.fileIdLogo;
      const currentFileId = currentFile?.id;

      // Fetch file if:
      // 1. Company has a fileIdLogo and we don't have it loaded yet
      // 2. Or we don't have any file loaded
      if (
        (companyFileId && companyFileId !== currentFileId) ||
        (!currentFile?.id && !companyFileId)
      ) {
        console.log('🔍 [Main Layout] Fetching file for userId:', userId);
        console.log('🔍 [Main Layout] Company fileIdLogo:', companyFileId);
        console.log('🔍 [Main Layout] Current file id:', currentFileId);
        dispatch(findFileByUserId({ userId }));
      }
    }
  }, [userId, currentCompany.fileIdLogo, currentFile.id, dispatch]);

  const handleSidebarOpen = () => {
    setOpenSidebar(true);
  };

  const handleSidebarClose = () => {
    setOpenSidebar(false);
  };

  const shouldOpenSidebar = isDesktop ? true : openSidebar;
  return (
    <div
      className={clsx({
        [classes.root]: true,
        [classes.shiftContent]: isDesktop
      })}>
      <TopBar onSidebarOpen={handleSidebarOpen} />
      <Sidebar
        onClose={handleSidebarClose}
        open={shouldOpenSidebar}
        variant={isDesktop ? 'persistent' : 'temporary'}
      />
      <main className={classes.content}>{children}</main>
    </div>
  );
};

Main.propTypes = {
  children: PropTypes.node
};

export default Main;
